import React, {useRef, useEffect} from "react";
import { motion, AnimatePresence } from 'framer-motion';
import { UserCircle2, User, Bookmark, LogOut, FileText, Users } from "lucide-react";
import { Link } from 'react-router-dom';
import { ChevronDown } from "lucide-react";

const HeaderDropdown = ({isOpen, onClose, user, onLogout, translations}) => {
    const dropdownRef = useRef(null);

    const menuItems = [
        {
            icon: User,
            label: translations('nav.profile') || 'Profile',
            to: '/profile'
        },
        {
            icon: FileText,
            label: translations('scenarios.title') || 'My Scenarios',
            to: '/myscenarios'
        },
        /*
        {
            icon: Calendar,
            label: translations('nav.mySchedules') || 'My Schedules',
            to: '/schedules'
        },
        */
        {
            icon: Users, 
            label: translations('nav.myTeams') || 'My Teams',
            to: '/teams' 
        },
        /*
        {
            icon: FileText,
            label: translations('nav.myDrafts') || 'My Drafts',
            to: '/drafts'
        },
        */
        {
            icon: Bookmark,
            label: translations('nav.mySubscription') || 'My Subscription',
            to: '/subscription'
        }
    ];

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if(dropdownRef.current && !dropdownRef.current.contains(event.target)){
                onClose();
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, [onClose]);

    return (
        <div className="relative" ref={dropdownRef}>
        <motion.button
            whileHover={{ backgroundColor: "#f3f4f6" }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onClose(!isOpen)}
            className="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-gray-100 transition-all duration-75"
        >
        <div className="relative">
            <UserCircle2 className="h-9 w-9 text-indigo-600" />
            <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-500 border-2 border-white rounded-full" />
        </div>
        <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-gray-700">{user.firstName}</span>
            <motion.div
                animate={{ rotate: isOpen ? 180 : 0 }}
                transition={{ duration: 0.2 }}
            >
                <ChevronDown className="w-4 h-4 text-gray-400" />
            </motion.div>
        </div>
        </motion.button>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity:1, y: 0 }}
                        exit={{ opacity:0, y: -10 }}
                        transition={{ duration:0.2 }}
                        className="absolute right-0 mt-2 w-72 rounded-lg bg-white shadow-xl border border-gray-100 py-2 z-50"
                    >
                        <div className="px-4 py-2 border-b border-gray-100">
                            <p className="text-sm text-gray-500">{translations("nav.signedAs")}</p>
                            <p className="text-sm font-semibold text-gray-700 truncate">
                                {user.email}
                            </p>
                        </div>

                        <div className="py-2">
                            {menuItems.map((item, index) => (
                                <Link
                                    key={index}
                                    to={item.to}
                                    className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                                    onClick={() => onClose(false)} 
                                >
                                    <item.icon className="h-5 w-5 mr-3 text-gray-500"/>
                                    {item.label}
                                </Link>
                            ))}
                        </div>

                        <div className="border-t border-gray-100 pt-2">
                            <button
                                onClick={() => {
                                    onClose();
                                    onLogout();
                                }}
                                className="flex items-center w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors"
                            >
                                <LogOut className="h-5 w-5 mr-3"/>
                                {translations('nav.signOut') || 'Sign out'}
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default HeaderDropdown